// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const SAVE_TO_RESULTS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.SAVE_TO_RESULTS,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Saved results': {
        systemName: 'Saved results',
        displayName: 'Saved results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Rows with errors': {
        systemName: 'Rows with errors',
        displayName: 'Rows with errors',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: null
  },
  {
    stepType: PipelineStepType.SAVE_TO_RESULTS,
    isDeprecated: false,
    version: 1,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Saved results': {
        systemName: 'Saved results',
        displayName: 'Saved results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Rows with errors': {
        systemName: 'Rows with errors',
        displayName: 'Rows with errors',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      schemaId: {
        kind: 'domain',
        required: true,
        types: [
          'RESULT_SCHEMA'
        ]
      },
      columnMapping: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            inputColumnSystemName: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Input dataset',
              allowMissingColumn: false,
              validationOptions: null
            },
            outputFieldId: {
              kind: 'string',
              required: true
            }
          }
        }
      }
    }
  },
  {
    stepType: PipelineStepType.SAVE_TO_RESULTS,
    isDeprecated: false,
    version: 2,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Saved results': {
        systemName: 'Saved results',
        displayName: 'Saved results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Rows with errors': {
        systemName: 'Rows with errors',
        displayName: 'Rows with errors',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      schemaId: {
        kind: 'domain',
        required: true,
        types: [
          'RESULT_SCHEMA'
        ]
      },
      columnMapping: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            inputColumnSystemName: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Input dataset',
              allowMissingColumn: false,
              validationOptions: null
            },
            outputFieldId: {
              kind: 'string',
              required: true
            }
          }
        }
      },
      targetSpecificMapping: {
        kind: 'shape',
        required: false,
        fields: {
          target: {
            kind: 'enum',
            required: true,
            choices: [
              'TEST_ORDER_TABLE'
            ]
          },
          targetVersion: {
            kind: 'integer',
            required: true,
            minValue: 0,
            maxValue: 0
          },
          columnMappings: {
            kind: 'array',
            required: true,
            elementSpec: {
              kind: 'shape',
              required: true,
              fields: {
                inputColumnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                },
                outputColumnSystemName: {
                  kind: 'string',
                  required: true
                }
              }
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
